import { FieldHasValue } from 'helpers/Validation';

export const AsFoundResultP723Formula = (formData) => {
    if (FieldHasValue(formData.F460AftPushbuttonWasActivatedInField) && FieldHasValue(formData.F372AftHmistatus1)) {
        if (formData.F460AftPushbuttonWasActivatedInField === 'YES' && formData.F372AftHmistatus1 === 'ALARM') {
            return 'PASS';
        }
        return 'FAIL';
    }
    return '';
};
